import { render, staticRenderFns } from "./IChecklist.vue?vue&type=template&id=be347a62&"
import script from "./IChecklist.vue?vue&type=script&lang=ts&"
export * from "./IChecklist.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports